import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "../data/loadData";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBlogPageDataIfNeeded } from "@Pages/Blog/BlogPost/data/blogPageReducer";
import { getBlogLanguageFromPath } from "@Pages/Blog/utils/blogLanguage";

const BlogGrid = loadable(() => import("./BlogGrid"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (__CLIENT__) {
      const path = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);
      const isCategory = path.includes("/category/");
      const isTag = path.includes("/tag/");
      const isLatest = path.includes("/latest");
      const isSearch = path.includes("/search");
      const searchQuery = searchParams.get("query") || searchParams.get("q") || "";

      const lang = getBlogLanguageFromPath(path);

      dispatch(
        fetchBlogPageDataIfNeeded(
          props,
          isCategory,
          isTag,
          isSearch,
          searchQuery,
          isLatest,
          false,
          lang,
        ),
      );
    }
  }, [dispatch, props?.match?.params?.slug, props?.match?.params?.lang, props?.location?.search]);

  return (
    <ErrorBoundary>
      <BlogGrid {...props} />
    </ErrorBoundary>
  );
};

export { BlogGrid as PreFetchBlogGrid };
export { loadData };
